<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">
              <i class="fas fa-flask" /> Inputs
            </h4>
            <h6 class="card-subtitle">
              Create new inputs for farm.
            </h6>
          </div>
          <div class="card-body">
            <ul id="pills-tab" class="nav nav-pills custom-pills owm" role="tablist">
              <li class="nav-item" @click="tab('seed')">
                <a class="nav-link active show" data-toggle="pill" href="#seed" role="tab" aria-selected="true">
                  <h5 class="m-b-0 text-dark">Seed</h5>
                </a>
              </li>
              <li class="nav-item" @click="tab('chemical')">
                <a class="nav-link" data-toggle="pill" href="#chemical" role="tab" aria-selected="false">
                  <h5 class="m-b-0 text-dark">Chemical</h5>
                </a>
              </li>
              <li class="nav-item" @click="tab('fertilizer')">
                <a class="nav-link" data-toggle="pill" href="#fertilizer" role="tab" aria-selected="false">
                  <h5 class="m-b-0 text-dark">Fertilizer</h5>
                </a>
              </li>
            </ul>
            <!-- Tab panes -->
            <div class="tab-content">
              <div id="seed" class="tab-pane p-20 active" role="tabpanel">
                <seed v-if="activeTab === 'seed'" />
              </div>
              <div id="chemical" class="tab-pane p-20 active" role="tabpanel">
                <chemical v-if="activeTab === 'chemical'" />
              </div>
              <div id="fertilizer" class="tab-pane p-20 active" role="tabpanel">
                <fertilizer v-if="activeTab === 'fertilizer'" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Seed from './Seed'
import Chemical from './Chemical'
import Fertilizer from './Fertilizer'

export default {
  name: 'Inputs',
  components: { Seed, Chemical, Fertilizer },
  data () {
    return {
      activeTab: 'seed'
    }
  },
  methods: {
    tab (tabName) {
      this.activeTab = tabName
    }
  }
}
</script>

<style scoped>
</style>
